import React from 'react';

import { cn } from '@/services/utils';

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
    containerClassName?: string;
}

const Table = React.forwardRef<HTMLTableElement, TableProps>(
    ({ className, containerClassName, ...props }, ref) => {
        return (
            <div
                className={cn('tw-w-full', containerClassName)}
            >
                <table
                    ref={ref}
                    className={cn(
                        'scoped-table tw-w-full tw-border-collapse tw-caption-bottom tw-text-t-sm',
                        className,
                    )}
                    {...props}
                />
            </div>
        );
    },
);

Table.displayName = 'Table';

export { Table };
